import { IFormDocument } from 'app/services/api5-service/api.interface';

import { getPhoneControls } from './phone/get-phone';
import { getPromocodeControls } from './promocode/get-promocode';

import { TypedControl } from '../controls';

/**
 * Some BE controls combinations are merged on FE into one control
 *
 * @param controls
 * @param doc
 */
export function getCombinedControls(
  controls: TypedControl[],
  doc: IFormDocument,
): TypedControl[] {
  return getPhoneControls(getPromocodeControls(controls), doc);
}
